import React, { useState } from 'react';
import { Spinner } from 'react-bootstrap';
import { BfCheckboxContainer, BfCheckboxInput, BfButtonBlue } from '../../../Styling/styledForm/styledBlueForm'
import {
  StyledModal,
  StyledModalBody,
  StyledModalFooter,

} from "../../../Styling/styledModal/styledModals";
import styled from 'styled-components';

const CheckboxText = styled.span`
  font-size: 1.2rem; 
  padding-left: 20px;
  text-align: center;
  font-family: "RM Neue", "sans-serif";
`;

const BislabTermsModal = (props) => {
  const { dialogVisible, cancelHandler, acceptHandler, shouldFetch } = props.termsModal;

  const [checked, setChecked] = useState(false);
  const messages = props.termsModal.messages;
  const state = props.state;
  const pdfBase64 = state.termsBase64;
  const viewOnlyMode = props.viewOnlyMode;

  const handleOkClick = () => {
    if (checked) {
      acceptHandler();
    }
  };

  const handleCancelClick = () => {
    cancelHandler();
  };

  const handleChange = () => {
    setChecked(!checked);
  };


  return (
    <StyledModal show={props.termsModal.dialogVisible} centered size="lg" style={{ transform: 'translate(-10%, 0%)' }} >
      <StyledModalBody style={{ width: '150%' }}>
        {!viewOnlyMode && (<h4>{messages.accept_terms}</h4>)}
        {!viewOnlyMode && (<p>{messages.terms_caption}</p>)}
        {shouldFetch ? (
          <div style={{ width: '100%', height: '70vh', border: 'none' }} className="d-flex justify-content-center align-items-center">
            <Spinner animation="border" />
          </div>
        ) : 
        (
          pdfBase64 ? (
            <iframe
              title="PDF Viewer"
              src={pdfBase64}
              style={{ width: '100%', height: '70vh', border: 'none' }}
            />
          ) : (
            <p>Noe gikk galt ved lasting av dokument</p>
          )
        )}
      </StyledModalBody>

      <StyledModalFooter style={{ width: '150%', paddingRight: '10px' }}>
        {!viewOnlyMode && (<BfCheckboxContainer style={{display: 'flex'}}>
          <BfCheckboxInput
            checked={checked}
            onChange={handleChange}
            disabled={false}
          />
          <CheckboxText>{messages.checkbox_text}</CheckboxText>

        </BfCheckboxContainer>)}
        <div style={{ display: 'flex', width: '100%', padding: '20px 0 20px 0' }}>
          {!viewOnlyMode && (<BfButtonBlue variant="secondary" onClick={handleOkClick} disabled={!checked}>
            {messages.accept}
          </BfButtonBlue>)}
          &nbsp;
          &nbsp;
          <BfButtonBlue variant="primary" onClick={handleCancelClick}>
            {messages.cancel}
          </BfButtonBlue>
        </div>
      </StyledModalFooter>
    </StyledModal>
  );
};

export default BislabTermsModal;

